import { render, staticRenderFns } from "./ApplicantAddress.vue?vue&type=template&id=4d949979&"
import script from "./ApplicantAddress.vue?vue&type=script&lang=js&"
export * from "./ApplicantAddress.vue?vue&type=script&lang=js&"
import style0 from "./ApplicantAddress.vue?vue&type=style&index=0&id=4d949979&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports